<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-layout row wrap>
      <v-flex xs12 class="pt-0">
        <v-card flat>
          <v-card-title class="pt-2">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by phone no, email, etc.':'Search'"
                single-line
                hide-details
                v-model="search"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                :headers="notifyLoghead"
                :items="notifyLogs"
                :landscape = "true"
                :fontsize = "8"
                :cellpadding = "1"
                title="Notification logs"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp?notifyLogHeadersm:notifyLogHeader"
            :items="notifyLogs"
            :rows-per-page-items = "[10,25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            :pagination.sync="paginationRowsPerPage"
            class="elevation-1"
            disable-initial-sort
            :search="search"
            >
            <template slot="items" slot-scope="props">
              <tr>
                <td class="pa-2">{{ props.item.notify_time }}</td>
                <td class="pa-2">{{ props.item.template }}</td>
                <td class="pa-2">{{ props.item.notify_type}}</td>
                <td class="pa-2">{{ props.item.contact_email || 'NA'}}</td>
                <td class="pa-2">{{ props.item.contact_phone || 'NA'}}</td>
                <td class="pa-2">{{ props.item.cust_name || 'NA' }}</td>
                <td class="pa-2">{{ props.item.notify_result }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp" class="pa-2">{{ props.item.msg_title || '-' }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.msg_text }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-btn dark fab fixed color="accent"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:65px; left:25px;':'bottom:15px; left:320px;')"
    @click.native="prepareFilter">
    <v-badge overlap color="info">
      <template v-slot:badge v-if="enabledFilter">
        <v-icon class="caption">done</v-icon>
      </template>
      <v-icon class="pa-2">filter_list</v-icon>
    </v-badge>
  </v-btn>
</v-layout>

<!--1. show filter category in bottom sheet -->
<v-bottom-sheet inset class="caption" v-model="showFilter" max-width="500px">
  <v-card>
    <v-card-text>
      <v-container grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="caption primary--text">Filter by attributes</div>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            label="Context"
            v-model="filter.template"
            hide-details
            maxlength="30"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filter.notify_type_list"
            :items="['Email', 'SMS', 'Push']"
            label="Type"
            hide-details
            small-chips
            clearable
            dense
            multiple
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filter.user_list"
            label="User"
            :items="users"
            item-text="user_name"
            item-value="user_id"
            hide-details
            small-chips
            clearable
            dense
            multiple
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            label="Mobile no."
            v-model="filter.contact_phone"
            hide-details
            maxlength="15"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
            label="E-mail"
            v-model="filter.contact_email"
            hide-details
            maxlength="50"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filter.notify_result_list"
            :items="['Success', 'Fail']"
            label="Status"
            hide-details
            small-chips
            clearable
            dense
            multiple
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <div class="caption primary--text pt-3">Filter by date</div>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="dlgFromDate"
            persistent v-model="dlgFromDate"
            lazy max-width="290px"
            :return-value.sync="filter.from_dt"
            >
            <v-text-field
            slot="activator" label="From date"
            v-model="filter.from_dt"
            append-icon="event"
            readonly clearable
            hide-details
            ></v-text-field>
            <v-date-picker v-model="filter.from_dt" scrollable
            first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn flat @click="dlgFromDate = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.dlgFromDate.save(filter.from_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs6>
        <v-dialog ref="dlgToDate"
        persistent v-model="dlgToDate"
        lazy max-width="290px"
        :return-value.sync="filter.to_dt"
        >
        <v-text-field
        slot="activator" label="To date"
        v-model="filter.to_dt"
        append-icon="event"
        readonly clearable
        hide-details
        ></v-text-field>
        <v-date-picker v-model="filter.to_dt" scrollable
        first-day-of-week="1"
        >
        <v-spacer></v-spacer>
        <v-btn flat @click="dlgToDate = false">Cancel</v-btn>
        <v-btn flat color="accent" @click="$refs.dlgToDate.save(filter.to_dt)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-flex>
</v-layout>
</v-container>
</v-card-text>
<v-card-actions>
  <v-btn flat @click.stop="showFilter = false">Close</v-btn>
  <v-spacer></v-spacer>
  <v-btn flat @click="clearFilter">Clear all</v-btn>
  <v-btn class="ma-0" flat color="accent" @click="applyFilter">Apply</v-btn>
</v-card-actions>
</v-card>
</v-bottom-sheet>

<v-snackbar :color="sbarCol" v-model="sbar" :timeout="2000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<div v-if="load" style="position:absolute; top:20%; left:50%">
  <v-progress-circular indeterminate color="primary"></v-progress-circular>
</div>

</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbarMsg: '',
      sbar: false,
      load: false,
      sbarCol: 'error',
      notifyLogs: [],
      notifyLogHeadersm: [
        { text: 'Time', value: 'notify_time', width: '100px', class: 'pa-2' },
        { text: 'Context', value: 'template', class: 'pa-2' },
        { text: 'Type', value: 'notify_type', class: 'pa-2' },
        { text: 'Email', value: 'contact_email', class: 'pa-2' },
        { text: 'SMS', value: 'contact_phone', class: 'pa-2' },
        { text: 'User', value: 'cust_name', class: 'pa-2' },
        { text: 'Status', value: 'notify_result', class: 'pa-2' },
        { text: 'Title', value: 'msg_title', class: 'pa-2' },
        { text: 'Text', value: 'msg_text', width: '250px' }
      ],
      notifyLogHeader: [
        { text: 'Time', value: 'notify_time', width: '100px', class: 'pa-2' },
        { text: 'Context', value: 'template', class: 'pa-2' },
        { text: 'Type', value: 'notify_type', class: 'pa-2' },
        { text: 'Email', value: 'contact_email', class: 'pa-2' },
        { text: 'SMS', value: 'contact_phone', class: 'pa-2' },
        { text: 'User', value: 'cust_name', class: 'pa-2' },
        { text: 'Status', value: 'notify_result', class: 'pa-2' }
      ],
      notifyLoghead: [
        { text: 'Time', value: 'notify_time' },
        { text: 'Context', value: 'template' },
        { text: 'Type', value: 'notify_type' },
        { text: 'Email', value: 'contact_email' },
        { text: 'SMS', value: 'contact_phone' },
        { text: 'User', value: 'cust_name' },
        { text: 'Status', value: 'notify_result' },
        { text: 'Title', value: 'msg_title' },
        { text: 'Text', value: 'msg_text' }
      ],
      handy: handy,
      search: '',
      // filters
      showFilter: false,
      enabledFilter: false,
      filter: {
        notify_type_list: [],
        notify_result_list: [],
        template: '',
        user_list: [],
        contact_phone: '',
        contact_email: '',
        from_dt: null,
        to_dt: null
      },
      dlgFromDate: false,
      dlgToDate: false,
      users: [],
      paginationRowsPerPage: { rowsPerPage: 25 }
    }
  },
  created () {
    this.loadNotifyDetails()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
    },
    loadNotifyDetails () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          filter: this.filter
        }
      }
      this.load = true
      this.axios.get(config.API_URL + '/getNotifyLogByCommId/', qry)
      .then(response => {
        this.notifyLogs = response.data
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
        this.notifyLogs = []
        this.load = false
      })
    },
    loadUsers () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getListOfUserByCommId/', qry)
      .then(response => {
        this.users = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.users = []
      })
    },
    prepareFilter () {
      this.loadUsers()
      this.showFilter = true
    },
    applyFilter () {
      if (this.filter.from_dt > this.filter.to_dt) {
        this.msg('to date should be greater than from date')
      } else {
        if (!this.filter.from_dt && this.filter.to_dt) {
          this.filter.from_dt = this.filter.to_dt
        } else if (this.filter.from_dt && !this.filter.to_dt) {
          this.filter.to_dt = this.filter.from_dt
        }
      }
      if (this.filter.notify_type_list.length || this.filter.user_list.length || this.filter.contact_phone || this.filter.contact_email || this.filter.notify_result_list.length || this.filter.template || this.filter.from_dt || this.filter.to_dt) {
        this.enabledFilter = true
        this.loadNotifyDetails()
        this.showFilter = false
      }
    },
    clearFilter () {
      this.filter.notify_type_list = []
      this.filter.notify_result_list = []
      this.filter.user_list = []
      this.filter.template = ''
      this.filter.contact_phone = ''
      this.filter.contact_email = ''
      this.filter.from_dt = null
      this.filter.to_dt = null
      this.loadNotifyDetails()
      this.enabledFilter = false
      this.showFilter = false
      this.$forceUpdate()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Notifylogs.vue?0c59efa9